import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';

export async function validateRoutePerms(perms) {
  try {
    const res = await tryCache('validateRoutePerms' + '-' + perms, () =>
      apiClient.post('/users/permissions/validate', {
        perms,
      }),
    );
    return res;
  } catch (error) {
    console.error('validateRoutePerms failed.', error);
  }
}

export async function getUserPerms() {
  try {
    const res = await tryCache('getUserPerms', () => apiClient.get('/users/permissions'));
    return res;
  } catch (error) {
    console.error('getUserPerms failed.', error);
  }
}

export async function getPermissionsMeta() {
  try {
    const res = await tryCache('getPermissionsMeta', () =>
      apiClient.get('/users/permissions/meta'),
    );
    return res;
  } catch (error) {
    console.error('getPermissionsMeta failed.', error);
  }
}

export async function getAccessLevel() {
  try {
    const res = await tryCache('checkAuthLevel', () => apiClient.get('/users/auth-level'));
    return res;
  } catch (error) {
    console.error('getAccessLevel failed.', error);
  }
}

export async function getGlobalWidgetPermList() {
  try {
    const res = await tryCache('getGlobalWidgetPermList', () =>
      apiClient.get('/license/widgets/permissions'),
    );
    return res;
  } catch (error) {
    console.error('getGlobalWidgetPermList failed.', error);
  }
}
